<template>
    <div>
        <v-chip class="mr-3 font-weight-bold" dark label small v-bind:value="value"
                :color="selected === 'live' ? ada.pink : ada.grey" @click="updateSelected('live')">
            LIVE
        </v-chip>
        <v-chip class="mr-3 font-weight-bold" dark label small v-bind:value="value"
                :color="selected === 'stage' ? ada.blue : ada.grey" @click="updateSelected('stage')">
            STAGE
        </v-chip>
    </div>
</template>

<script>
import ada from "../../../scss/ada_colors.scss";

export default {
    name: "LiveStageToggle",
    props: ['value'],
    data: () => {
        return {
            selected: 'live',
            ada
        }
    },
    mounted() {
        if (this.value) this.selected = this.value;
    },
    methods: {
        updateSelected(type) {
            this.selected = type;
            this.$emit('input', this.selected);
        }
    }
}
</script>

<style scoped>

</style>